import { KTSVG } from "_metronic/helpers";
import { FC, useEffect, useState } from "react";

type InputFields = {
    name: JSX.Element;
    number: JSX.Element;
};

type Props = {
    handleFilterClose: () => void,
    handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    selectedOption: string,
    employeeName: string,
    employeeNumber: string,
    setEmployeeName: (name: string) => void,
    setEmployeeNumber: (number: string) => void,
    setSelectedOption: (option: string) => void,
    setCurrentPage: (currentPage: number) => void,
    setIsFiltered: (isFiltered: boolean) => void,
    fetchData: () => void,
    fetchFilterData?: (name?:string, code?:string) => void,
    fetchFilterData2?: (name?:string, code?:string) => void,
    nameOptions?: string[],
    showSelect?: boolean,
}

const FilterView: FC<Props> = ({ 
    handleFilterClose, 
    handleSelectChange, 
    selectedOption, 
    employeeName, 
    employeeNumber,
    setEmployeeName,
    setEmployeeNumber,
    setSelectedOption,
    setCurrentPage,
    setIsFiltered,
    fetchData,
    fetchFilterData,
    fetchFilterData2,
    nameOptions = ['Código', 'Descripción'],
    showSelect = true,
}) => {
    const [tempEmployeeName, setTempEmployeeName] = useState(employeeName);
    const [tempEmployeeNumber, setTempEmployeeNumber] = useState(employeeNumber);

    const filterOptions = [
        { id: '1', name: nameOptions[0], field: 'name' },
        { id: '2', name: nameOptions[1], field: 'number' },
    ];

    const inputFields: InputFields = {
        name: (
            <>
                <div className="mt-4">
                    <label className="form-label fw-bold">{nameOptions[0]}: </label>
                </div>
                <div>
                    <input
                        type="text"
                        value={tempEmployeeName}
                        className="form-control mt-4"
                        onChange={(e) => setTempEmployeeName(e.target.value.trim())}
                    />
                    <div className="mt-4 d-flex flex-row-reverse">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            data-kt-menu-dismiss="true"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSearch();
                                handleFilterClose();
                            }}
                        >
                            Buscar
                        </button>
                        <button
                            type="reset"
                            className="btn btn-white btn-active-light-primary me-2"
                            data-kt-menu-dismiss="true"
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterClose();
                                handleClearFilters();
                            }}
                        >
                            Limpiar
                        </button>
                    </div>
                </div>
            </>
        ),
        number: (
            <>
                <div className="mt-4">
                    <label className="form-label fw-bold">{nameOptions[1]}: </label>
                </div>
                <div>
                    <input
                        type="text"
                        value={tempEmployeeNumber}
                        className="form-control mt-4"
                        onChange={(e) => setTempEmployeeNumber(e.target.value)}
                    />
                    <div className="mt-4 d-flex flex-row-reverse">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            data-kt-menu-dismiss="true"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSearch();
                                handleFilterClose();
                            }}
                        >
                            Buscar
                        </button>
                        <button
                            type="reset"
                            className="btn btn-white btn-active-light-primary me-2"
                            data-kt-menu-dismiss="true"
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterClose();
                                handleClearFilters();
                            }}
                        >
                            Limpiar
                        </button>
                    </div>
                </div>
            </>
        ),
    };

    

    const fieldToShow = filterOptions.find(
        (option) => option.id === selectedOption
    )?.field;

    useEffect(() => {
        if (!showSelect) {
            setSelectedOption("1");
        }
    }, [showSelect, setSelectedOption]);
    

    /**
    * Clean all the filters, inputs and fetch again the data
    */
    const handleClearFilters = () => {
        setEmployeeNumber('');
        setEmployeeName('');
        setSelectedOption('');
        setIsFiltered(false);
        setCurrentPage(1);
        
        if (!fetchFilterData && !fetchFilterData2) {
            fetchData();
        }
    };

    const handleSearch = () => {
        setEmployeeName(tempEmployeeName);
        setEmployeeNumber(tempEmployeeNumber);

        setIsFiltered(true);
        setCurrentPage(1);

        if (selectedOption === '1' && tempEmployeeName) {
            fetchFilterData && fetchFilterData(tempEmployeeName);
        } else if (selectedOption === '2' && tempEmployeeNumber) {
            fetchFilterData2 && fetchFilterData2(tempEmployeeNumber);
        }
    };

    return (
        <div className="modal-content">
            <div className="modal-header">
                <h1 className="text-muted mx-5">Filtrar Resultados</h1>
                <div
                    className="btn btn-sm btn-icon btn-active-color-primary"
                    onClick={handleFilterClose}
                >
                    <KTSVG
                        className="svg-icon-2"
                        path="/media/icons/duotune/arrows/arr061.svg"
                    />
                </div>
            </div>
            <div className="modal-body mx-5 padding-top-00">
                {showSelect ? (
                    <>
                        <div className="mt-4">
                            <label className="form-label fw-bold">Seleccione una opción:</label>
                        </div>
                        <select
                            className="form-select"
                            value={selectedOption}
                            onChange={handleSelectChange}
                        >
                            <option value="">Seleccione</option>
                            {filterOptions.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                            ))}
                        </select>
                        {fieldToShow && inputFields[fieldToShow as keyof InputFields]}
                    </>
                ): (
                    
                    inputFields.name
                )}
            </div>
        </div>
    )
}

export { FilterView }